var _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _descriptor8, _descriptor9, _descriptor10, _descriptor11, _descriptor12, _descriptor13, _descriptor14;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import Controller from '@ember/controller';
import { action } from '@ember/object';
import { service } from '@ember/service';
import { tracked } from '@glimmer/tracking';
import { DateTime } from 'luxon';
import { findById } from 'ilios-common/utils/array-helpers';
let DashboardCalendarController = (_class = class DashboardCalendarController extends Controller {
  constructor(...args) {
    super(...args);
    _initializerDefineProperty(this, "currentUser", _descriptor, this);
    _initializerDefineProperty(this, "router", _descriptor2, this);
    _initializerDefineProperty(this, "store", _descriptor3, this);
    _defineProperty(this, "queryParams", ['cohorts', 'courseFilters', 'courseLevels', 'courses', 'date', 'mySchedule', 'school', 'sessionTypes', 'showFilters', 'terms', 'view']);
    _initializerDefineProperty(this, "courseFilters", _descriptor4, this);
    _initializerDefineProperty(this, "cohorts", _descriptor5, this);
    _initializerDefineProperty(this, "courseLevels", _descriptor6, this);
    _initializerDefineProperty(this, "courses", _descriptor7, this);
    _initializerDefineProperty(this, "terms", _descriptor8, this);
    _initializerDefineProperty(this, "sessionTypes", _descriptor9, this);
    _initializerDefineProperty(this, "date", _descriptor10, this);
    _initializerDefineProperty(this, "mySchedule", _descriptor11, this);
    _initializerDefineProperty(this, "school", _descriptor12, this);
    _initializerDefineProperty(this, "showFilters", _descriptor13, this);
    _initializerDefineProperty(this, "view", _descriptor14, this);
  }
  get selectedSchool() {
    const {
      schools
    } = this.model;
    return findById(schools, this.school);
  }
  get selectedDate() {
    if (this.date) {
      const dt = DateTime.fromFormat(this.date, 'yyyy-MM-dd');
      if (dt.isValid) {
        return dt.toJSDate();
      } else {
        console.error(`date in URL is invalid: ${dt.invalidExplanation}`);
      }
    }
    return DateTime.now().toJSDate();
  }
  get selectedView() {
    if (!['month', 'week', 'day'].includes(this.view)) {
      return 'week';
    }
    return this.view;
  }
  changeDate(newDate) {
    this.date = DateTime.fromISO(newDate).toFormat('yyyy-MM-dd');
  }
  selectEvent(event) {
    this.router.transitionTo('events', event.slug);
  }
  toggleMySchedule() {
    if (this.mySchedule) {
      this.mySchedule = false;
      this.school = null;
    } else {
      this.mySchedule = true;
    }
  }
  toggleShowFilters() {
    if (this.showFilters) {
      this.showFilters = false;
      this.academicYear = null;
    } else {
      this.showFilters = true;
    }
  }
  add(what, id) {
    const str = this[what];
    if (str) {
      const idArray = str.split('-');
      if (!idArray.includes(id)) {
        this[what] = str + `-${id}`;
      }
    } else {
      this[what] = id;
    }
  }
  remove(what, id) {
    const str = this[what];
    if (str) {
      const idArray = str.split('-');
      if (idArray.includes(id)) {
        idArray.splice(idArray.indexOf(id), 1);
        this[what] = idArray.join('-');
      }
    }
  }
  clearFilters() {
    this.cohorts = '';
    this.courseLevels = '';
    this.courses = '';
    this.sessionTypes = '';
    this.terms = '';
  }
}, _descriptor = _applyDecoratedDescriptor(_class.prototype, "currentUser", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "router", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "store", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "courseFilters", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return true;
  }
}), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "cohorts", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return '';
  }
}), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, "courseLevels", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return '';
  }
}), _descriptor7 = _applyDecoratedDescriptor(_class.prototype, "courses", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return '';
  }
}), _descriptor8 = _applyDecoratedDescriptor(_class.prototype, "terms", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return '';
  }
}), _descriptor9 = _applyDecoratedDescriptor(_class.prototype, "sessionTypes", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return '';
  }
}), _descriptor10 = _applyDecoratedDescriptor(_class.prototype, "date", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return null;
  }
}), _descriptor11 = _applyDecoratedDescriptor(_class.prototype, "mySchedule", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return true;
  }
}), _descriptor12 = _applyDecoratedDescriptor(_class.prototype, "school", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return null;
  }
}), _descriptor13 = _applyDecoratedDescriptor(_class.prototype, "showFilters", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return false;
  }
}), _descriptor14 = _applyDecoratedDescriptor(_class.prototype, "view", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return 'week';
  }
}), _applyDecoratedDescriptor(_class.prototype, "changeDate", [action], Object.getOwnPropertyDescriptor(_class.prototype, "changeDate"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "selectEvent", [action], Object.getOwnPropertyDescriptor(_class.prototype, "selectEvent"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "toggleMySchedule", [action], Object.getOwnPropertyDescriptor(_class.prototype, "toggleMySchedule"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "toggleShowFilters", [action], Object.getOwnPropertyDescriptor(_class.prototype, "toggleShowFilters"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "add", [action], Object.getOwnPropertyDescriptor(_class.prototype, "add"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "remove", [action], Object.getOwnPropertyDescriptor(_class.prototype, "remove"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "clearFilters", [action], Object.getOwnPropertyDescriptor(_class.prototype, "clearFilters"), _class.prototype), _class);
export { DashboardCalendarController as default };